var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('List',_vm._l((_vm.messages),function(message,index){return _c('show-cell',{key:index,attrs:{"message":message,"statusRead":_vm.statusReads[index]}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }